import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  InputLabel,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Dropdown from "../../reusable_components/components/Dropdown";
import { useContext, useEffect, useState } from "react";
import {
  useEventsTableDatasMutation,
  useGetEventDropDownQuery,
  useMakeReferralCommissionMutation,
  useMakeReferralPaymentsMutation,
  useUpdateJobManageEventsMutation,
} from "../../redux/jobpostings/jobManageEvents.api";
import MUIButton from "../../reusable_components/components/MUIButton";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import {
  useDeleteEventHistoryMutation,
  useEventsHistoryMutation,
} from "../../redux/jobpostings/jobpostings.api";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import MuiDatePicker from "../../reusable_components/components/MuiDatePicker";
import CalendarIcon from "../../assets/Icons/CalendarIcon";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import Loader from "../../reusable_components/components/Loader";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import handshake from "../../assets/handshake.png";
import BonusIcon from "../../assets/bonus.png";
import Folders from "../../assets/folders.png";
import PersonIcon from "@mui/icons-material/Person";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import salary from "../../assets/deposit.png";
import Candidate from "../../assets/student.png";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const JobManageEvents = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { positionId, clientName, positionTitle, positionStatus } =
    location?.state || "";
  const { id, name, title } = location?.state || "";
  const { Profile } = useSelector((state) => state.common);
  const { Snackbar } = useContext(SnackbarContext);
  const userRole = Profile?.profile?.role;

  const status = positionStatus?.toString();

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [eventsTableListDatas, setEventsTableListDatas] = useState([]);
  const [originalEventsTableDatas, setOriginalEventsTableDatas] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [historyRowData, setHistoryRowData] = useState({});
  const [profileId, setProfileId] = useState("");
  const [historyTableDatas, setHistoryTableDatas] = useState([]);
  const [changedRows, setChangedRows] = useState([]);
  const [joiningDate, setJoiningDate] = useState(null);
  const [annualSalary, setAnnualSalary] = useState("");
  const [profileName, setProfileName] = useState("");
  const [clientId, setClientId] = useState("");
  const [triggerApi, setTriggerApi] = useState(false);
  const [showTableLoader, setShowTableLoader] = useState(false);
  const [showLoder, setShowLoder] = useState(false);
  const [openCommissionDialog, setOpenCommissionDialog] = useState(false);
  const [tentativeDate, setTentativeDate] = useState(null)

  const validationSchema = Yup.object().shape({
    joiningDate: Yup.string().required("Candidate joining date is required"),
    annualSalary: Yup.string().required(" Candidate Annual salary is required"),
  });

  const resolver = yupResolver(validationSchema);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    mode: "onChange",
    resolver,
    defaultValues: {
      joiningDate: null,
      annualSalary: "",
    },
  });

  const handleOpen = (item) => {
    setOpen(true);
    setProfileId(item?.profileId);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenPaymentDialog(false);
    setValue("annualSalary", "");
    setValue("joiningDate", null);
  };

  const handleOpenDelete = (item) => {
    setOpenDelete(true);
    setHistoryRowData(item);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleCloseCommissionDialog = () => {
    setOpenCommissionDialog(false);
  };

  const handleOpenPaymentDialog = (item) => {
    setOpenPaymentDialog(true);
    setProfileId(item?.profileId);
    setProfileName(item?.name);
    setClientId(item?.clientId);
  };

  const [eventsTableDatas] = useEventsTableDatasMutation();
  const { data: eventDropDown, refetch } = useGetEventDropDownQuery();
  const [eventHistory] = useEventsHistoryMutation();
  const [deleteEventHistory] = useDeleteEventHistoryMutation();
  const [updateEvents, { data: updatedEvents }] =
    useUpdateJobManageEventsMutation();
  const [makeReferralCommission] = useMakeReferralCommissionMutation();

  const handlePageChange = (e, newValue) => {
    setPage(newValue);
  };

  const handleRowsPerpageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleEventChange = (value) => {
    setSelectedEvent(value);
    setPage(1);
  };

  useEffect(() => {
    const getTableDatas = async () => {
      try {
        const payload = {
          eventTypeId: selectedEvent || 0,
          jobPostId: positionId ? positionId : id,
          page: 0,
          size: 10000,
        };
        setShowTableLoader(true);
        const response = await eventsTableDatas(payload).unwrap();
        setShowTableLoader(false);
        if (response?.status === 200) {
          setEventsTableListDatas(response?.response?.event || []);
          setOriginalEventsTableDatas(response?.response?.event || []);
          setTotalPageCount(response?.response?.count);
        }
      } catch (err) {
        Snackbar("Network error", "error");
      } finally {
        setShowTableLoader(false);
      }
    };
    getTableDatas();
  }, [eventsTableDatas, rowsPerPage, selectedEvent, updatedEvents, triggerApi]);

  const handleTableEventChange = (value, slicedIndex) => {
    const actualIndex = (page - 1) * rowsPerPage + slicedIndex;

    const originalEventTypeId = originalEventsTableDatas[actualIndex]?.eventTypeId;

    if (value === 10 && originalEventTypeId !== 9 && originalEventTypeId !== 10) {
      Snackbar("Only 'Offered' candidates can be changed to 'Joined'.", "error");
      return;
    }

    if (value === 16 && originalEventTypeId !== 10 && originalEventTypeId !== 16) {
      Snackbar("Only 'Joined candidates can be changed to 'Absconded'.", "error");
      return;
    }

    const updatedEvent = [...eventsTableListDatas];
    updatedEvent[actualIndex] = {
      ...updatedEvent[actualIndex],
      eventTypeId: value,
    };
    setEventsTableListDatas(updatedEvent);

    const historyId = eventsTableListDatas[actualIndex]?.viewHistory;
    if (!changedRows?.includes(historyId)) {
      setChangedRows((prev) => [...prev, historyId]);
    }
  };

  const handleRemarksChange = (e, slicedIndex) => {
    const value = e.target.value;
    const actualIndex = (page - 1) * rowsPerPage + slicedIndex;

    const updatedRemarks = [...eventsTableListDatas];
    updatedRemarks[actualIndex] = {
      ...updatedRemarks[actualIndex],
      remark: value,
    };
    setEventsTableListDatas(updatedRemarks);

    const historyId = eventsTableListDatas[actualIndex]?.viewHistory;
    if (!changedRows?.includes(historyId)) {
      setChangedRows((prev) => [...prev, historyId]);
    }
  };

  const handleChangeTentativeDate = (value, slicedIndex) => {
    const values = value
    const actualIndex = (page - 1) * rowsPerPage + slicedIndex;

    const updatedTentative = [...eventsTableListDatas];

    updatedTentative[actualIndex] = {
      ...updatedTentative[actualIndex],
      tentativeJoiningDate: values
    }
    setEventsTableListDatas(updatedTentative)
    const historyId = eventsTableListDatas[actualIndex]?.viewHistory;
    if (!changedRows?.includes(historyId)) {
      setChangedRows((prev) => [...prev, historyId]);
    }
  }

  const handleChangeJoiningDate = (value, slicedIndex) => {
    const values = value
    const actualIndex = (page - 1) * rowsPerPage + slicedIndex;

    const updateJoiningDate = [...eventsTableListDatas];
    updateJoiningDate[actualIndex] = {
      ...updateJoiningDate[actualIndex],
      finalJoiningDate: values,
    }
    setEventsTableListDatas(updateJoiningDate)
    const historyId = eventsTableListDatas[actualIndex]?.viewHistory;
    if (!changedRows?.includes(historyId)) {
      setChangedRows((prev) => [...prev, historyId]);
    }

  }

  useEffect(() => {
    const getHistoryTableDatas = async () => {
      try {
        const payload = {
          page: 0,
          positionId: positionId ? positionId : id,
          profileId: profileId,
          size: 5000,
        };
        if (open) {
          const response = await eventHistory(payload).unwrap();
          if (response?.status === 200) {
            setHistoryTableDatas(response?.response?.eventHistory);
          }
        }
      } catch (err) {
        Snackbar("Network error", "error");
      }
    };
    getHistoryTableDatas();
  }, [open]);

  const handleEventsHistoryDelete = async (item) => {
    try {
      const payload = {
        eventHistoryIds: [historyRowData?.eventHistoryId],
        profileMatchId: historyRowData?.profileMatchId,
      };

      const response = await deleteEventHistory(payload).unwrap();
      if (response?.status === 200) {
        Snackbar("The History deleted successfully", "success");
        handleClose();
        handleCloseDelete();
      }
    } catch (err) {
      Snackbar("Network error", "error");
    }
  };

  const handleSubmitProfileNavigation = () => {
    // navigate(`/submitprofiles/${positionId ? positionId : id}`, {
    //     state: { positionTitle: title ? title : positionTitle }
    // })
    navigate(-1);
  };

  const handleSaveHIstory = async () => {
    try {
      const modifiedItems = eventsTableListDatas?.filter((item) =>
        changedRows?.includes(item?.viewHistory)
      );

      const isJoiningDateMissing = modifiedItems?.some(
        (item) => item?.eventTypeId === 10 && (!item?.finalJoiningDate || item?.finalJoiningDate === "NA")
      );

      if (isJoiningDateMissing) {
        Snackbar("Candidate joining date is mandatory", "error");
        return;
      }

      const payload = {
        values: modifiedItems?.map((item) => ({
          comment: item?.remark || null,
          eventTypeId: item?.eventTypeId,
          profileMatchId: item?.profileMatchId,
          tentativeJoiningDate: item?.tentativeJoiningDate === "NA" ? null : dayjs(item?.tentativeJoiningDate).format('DD-MM-YYYY'),
          finalJoiningDate: item?.finalJoiningDate === "NA" ? null : dayjs(item?.finalJoiningDate).format('DD-MM-YYYY')
        })),
      };

      setShowLoder(true);
      const response = await updateEvents(payload).unwrap();
      setShowLoder(false);
      if (response?.status === 200) {
        Snackbar("The event has been updated successfully", "success");
        // navigate(`/submitprofiles/${positionId ? positionId : id}`, {
        //     state: { positionTitle: title ? title : positionTitle }
        // })
        // navigate('/jobpost')
        setTriggerApi(true);
      }
    } catch (err) {
      Snackbar("Network error", "error");
    }
  };

  const prevPath = location?.state?.submitProfilePath || "/jobpost";

  const handleBackNavigation = () => {
    // navigate(prevPath?.startsWith(`/submitprofiles/${id}`) ? `/submitprofiles/${id}` : '/jobpost')
    navigate(-1);
  };

  const handleJoiningDate = (value) => {
    setJoiningDate(value);
  };

  const handleAnnualSalary = (e) => {
    setAnnualSalary(e.target.value);
  };

  const [candidateCommissionAmount, setCandidateCommissionAmount] =
    useState("");
  const [jobCommissionAmount, setJobCommissionAmount] = useState("");
  const [clientCommissionAmount, setClientCommissionAmount] = useState("");
  const [
    candidateCommissionAmountEarnedBy,
    setCandidateCommissionAmountEarnedBy,
  ] = useState("");
  const [jobCommissionAmountEarnedBy, setJobCommissionAmountEarnedBy] =
    useState("");
  const [message, setMessage] = useState("");
  const [clientCommissionAmountEarnedBy, setClientCommissionAmountEarnedBy] =
    useState("");
  const [candidateSalary, setCandidateSalary] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [clientRewardPercentage, setClientRewardPercentage] = useState("10%");
  const [positionRewardPercentage, setPositionRewardPercentage] =
    useState("10%");
  const [candidateRewardPercentage, setCandidateRewardPercentage] =
    useState("10%");
  const [clientRewardType, setClientRewardType] = useState("");
  const [positionRewardType, setPositionRewardType] = useState("");
  const [candidateRewardType, setCandidateRewardType] = useState("");

  const onSubmit = async (data) => {
    try {
      const payload = {
        profileID: profileId,
        positionId: positionId,
        candidateJoiningDate: data?.joiningDate
          ? dayjs(data?.joiningDate)?.format("YYYY-MM-DD")
          : "",
        candidateAnnualSalary: +data?.annualSalary,
        clientId: clientId,
      };
      const response = await makeReferralCommission(payload).unwrap();
      if (response) {
        // Snackbar(response?.response?.message, 'success')
        setOpenCommissionDialog(true);
        setCandidateCommissionAmountEarnedBy(
          response?.response?.candidateCommissionAmountEarnedBy
        );
        setCandidateCommissionAmount(
          response?.response?.candidateCommissionAmount
        );
        setJobCommissionAmount(response?.response?.jobCommissionAmount);
        setJobCommissionAmountEarnedBy(
          response?.response?.jobCommissionAmountEarnedBy
        );
        setMessage(response?.response?.message);
        setClientCommissionAmount(response?.response?.clientCommissionAmount);
        setClientCommissionAmountEarnedBy(
          response?.response?.clientCommissionAmountEarnedBy
        );
        setCandidateSalary(response?.response?.candidateAnnualSalary);
        setCandidateName(response?.response?.candidateFullName);
        setClientRewardPercentage(
          response?.response?.clientRewardType === "FP"
            ? response?.response?.clientRewardPercentage
            : response?.response?.clientCommissionAmount
        );
        setPositionRewardPercentage(
          response?.response?.positionRewardType === "FP"
            ? response?.response?.positionRewardPercentage
            : response?.response?.jobCommissionAmount
        );
        setCandidateRewardPercentage(
          response?.response?.candidateRewardType === "FP"
            ? response?.response?.candidateRewardPercentage
            : response?.response?.candidateCommissionAmount
        );
        setPositionRewardType(response?.response?.positionRewardType);
        setCandidateRewardType(response?.response?.candidateRewardType);
        setClientRewardType(response?.response?.clientRewardType);
        setOpenPaymentDialog(false);
        setTriggerApi(false);
        setJoiningDate(null);
        setAnnualSalary("");
        setValue("annualSalary", "");
        setValue("joiningDate");
      }
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  return (
    <Box className="container">
      {showLoder ? <Loader /> : ""}
      <Grid2
        item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#6941C6",
          gap: "4px",
          cursor: "pointer",
          width: "40px",
        }}
        onClick={handleBackNavigation}
      >
        <ArrowBackIcon sx={{ fontSize: "17px" }} />
        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Back</Typography>
      </Grid2>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <Typography className="title"> Manage Job Stages </Typography>
        <div>
          <Typography
            sx={{ color: "#181D27", fontWeight: 600, fontSize: "16px" }}
          >
            {positionTitle ? positionTitle : title}
          </Typography>
          <Typography
            sx={{ color: "#535862", fontWeight: 400, fontSize: "14px" }}
          >
            {positionId ? positionId : id} {clientName ? clientName : name}
          </Typography>
        </div>
      </div>
      {
        positionStatus !== "Active" &&
        <Grid2
          sx={{
            border: "1px solid #FFD54F",
            padding: "12px 16px",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            backgroundColor: "#FFF8E1",
            justifyContent: "center",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          <WarningAmberIcon sx={{ color: "#FF9800" }} />
          <Typography sx={{ fontWeight: 500, color: "#5D4037" }}>
            This job is Currently Inactive, so you cannot do anything.
          </Typography>
        </Grid2>
      }

      <Grid2 container sx={{ marginTop: "5px" }}>
        <Grid2 item container sx={{ flexGrow: 1 }}>
          <Paper
            sx={{
              width: "100%",
              overflow: "auto",
              border: "1px solid #E9EAEB",
            }}
            elevation={0}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={100}>
                    <Grid2 item sx={{ width: "20%" }}>
                      <Dropdown
                        value={selectedEvent || ""}
                        onChange={handleEventChange}
                        options={eventDropDown?.response || []}
                        placeholder="Select an Event"
                        valueKey="eventTypeId"
                        labelKey="event"
                        sx={{ color: "#414651" }}
                      />
                    </Grid2>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="tableHeadersCell" sx={{ width: "25%" }}>
                    Name
                  </TableCell>
                  <TableCell className="tableHeadersCell" sx={{ width: "25%" }}>
                    Select Event
                  </TableCell>
                  <TableCell className="tableHeadersCell" sx={{ width: "25%" }}>
                    Remarks
                  </TableCell>
                  <TableCell className="tableHeadersCell" sx={{ width: "25%" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              {!showTableLoader ? (
                eventsTableListDatas?.length > 0 ? (
                  <TableBody>
                    {eventsTableListDatas
                      ?.slice((page - 1) * rowsPerPage, page * rowsPerPage)
                      ?.map((item, index) => {
                        const colors = [
                          "green",
                          "darkorange",
                          "purple",
                          "#3357FF",
                          "orangered",
                          "darkgreen",
                          "pink",
                        ];
                        let firstLetter = item?.name;
                        const letter = firstLetter?.charAt(0)?.toUpperCase();
                        const backgroundColor = colors[index % colors?.length];
                        return (
                          <Tooltip
                            key={index}
                            slotProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#0A0D12",
                                  borderRadius: "8px",
                                  padding: "8px 12px",
                                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                                },
                              },
                            }}
                            title={""}
                            placement="top"
                          >
                            <TableRow
                              sx={{
                                backgroundColor:
                                  index % 2 === 1 ? "#FAFAFA" : "inherit",
                                "&:hover": { backgroundColor: "#f1f1f1" },
                              }}
                              disabled={item?.candidateStatus === "ENA"}
                            >
                              <TableCell className="tableBodyCell" sx={{ width: "25%" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "13px",
                                  }}
                                >
                                  <Avatar sx={{ backgroundColor: backgroundColor }}>
                                    {letter}
                                  </Avatar>
                                  <div>
                                    <span
                                      style={{
                                        color: "#53389E",
                                        fontWeight: 550,
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        navigate(
                                          `/editcandidateprofile/${item?.profileId}`
                                        )
                                      }
                                    >
                                      {item?.name}
                                    </span>
                                    <br />
                                    <p style={{ color: "#535862", fontSize: "12px", margin: "2px 0" }}>
                                      {item?.email}
                                      <br />
                                      {item?.mobile}
                                    </p>
                                  </div>
                                </div>
                              </TableCell>

                              <TableCell className="tableBodyCell" sx={{ width: "25%" }}>
                                <Box sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 1,
                                  flexWrap: 'nowrap'
                                }}>
                                  <Box sx={{
                                    flex: item?.eventTypeId === 9 || item?.eventTypeId === 10 ? 1 : '100%',
                                    minWidth: item?.eventTypeId === 9 || item?.eventTypeId === 10 ? '140px' : '100%'
                                  }}>
                                    <Dropdown
                                      placeholder="Select an Event"
                                      sx={{
                                        width: '100%',
                                        fontSize: "13px",
                                        color: "#414651",
                                        '& .MuiInputBase-root': {
                                          fontSize: '13px',
                                          height: '35px',
                                        },
                                        '& .MuiSelect-select': {
                                          padding: '8px 32px 8px 12px',
                                          fontSize: '13px',
                                        }
                                      }}
                                      value={item?.eventTypeId || ""}
                                      onChange={(value) =>
                                        handleTableEventChange(value, index)
                                      }
                                      options={eventDropDown?.response || []}
                                      valueKey="eventTypeId"
                                      labelKey="event"
                                    // disabled={item?.candidateStatus === "ENA"}
                                    />
                                  </Box>

                                  {item?.eventTypeId === 9 && (
                                    <Box sx={{
                                      flexShrink: 0,
                                      width: '150px'
                                    }}>
                                      <MuiDatePicker
                                        slots={{
                                          openPickerIcon: CalendarIcon,
                                        }}
                                        value={
                                          item?.tentativeJoiningDate
                                            ? dayjs(item.tentativeJoiningDate)
                                            : null
                                        }
                                        onChange={(value) => handleChangeTentativeDate(value, index)}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            error: false,
                                            placeholder: "Tentative joining date",
                                            InputProps: {
                                              sx: {
                                                borderRadius: "10px",
                                                height: "35px",
                                                width: '100%',
                                                fontSize: '13px'
                                              },
                                            },
                                          },
                                        }}
                                        sx={{
                                          width: '100%',
                                          "& .MuiInputBase-input": {
                                            fontSize: "13px",
                                            padding: '8px 12px',
                                            height: 'auto',
                                          },
                                          "& .MuiSvgIcon-root": {
                                            fontSize: "18px",
                                          },
                                        }}
                                        format="DD-MM-YYYY"
                                        minDate={dayjs().subtract(10, "day")}
                                      />
                                    </Box>
                                  )}

                                  {item?.eventTypeId === 10 && (
                                    <Box sx={{
                                      flexShrink: 0,
                                      width: '150px'
                                    }}>
                                      <MuiDatePicker
                                        slots={{
                                          openPickerIcon: CalendarIcon,
                                        }}
                                        value={
                                          item?.finalJoiningDate
                                            ? dayjs(item.finalJoiningDate)
                                            : null
                                        }
                                        onChange={(value) => handleChangeJoiningDate(value, index)}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            error: false,
                                            placeholder: "Joining date",
                                            InputProps: {
                                              sx: {
                                                borderRadius: "10px",
                                                height: "35px",
                                                width: '100%',
                                                fontSize: '13px'
                                              },
                                            },
                                          },
                                        }}
                                        sx={{
                                          width: '100%',
                                          "& .MuiInputBase-input": {
                                            fontSize: "13px",
                                            padding: '8px 12px',
                                            height: 'auto',
                                          },
                                          "& .MuiSvgIcon-root": {
                                            fontSize: "18px",
                                          },
                                        }}
                                        format="DD-MM-YYYY"
                                        minDate={dayjs().subtract(10, "day")}
                                      />
                                    </Box>
                                  )}


                                </Box>
                              </TableCell>
                              <TableCell
                                className="tableBodyCell"
                                sx={{ width: "40%" }}
                              >
                                <textarea
                                  className="jobPostingTextAreas"
                                  placeholder="Enter a description..."
                                  style={{
                                    width: "90%",
                                    resize: "none",
                                    color: "#535862",
                                  }}
                                  value={item?.remark || ""}
                                  onChange={(e) =>
                                    handleRemarksChange(e, index)
                                  }
                                // disabled={item?.candidateStatus === "ENA"}
                                />
                              </TableCell>
                              <TableCell className="tableBodyCell" sx={{ width: "25%" }}>
                                <IconButton
                                  sx={{
                                    color: "#6941C6",
                                    fontSize: "12.5px",
                                    fontWeight: 600,
                                  }}
                                  onClick={() => handleOpen(item)}
                                >
                                  View History
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          </Tooltip>
                        );
                      })}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={8}>
                        <Typography className="emptydatas">
                          No Data Found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={13}>
                    <Box className="tableloader">
                      <TableLoader />
                    </Box>
                  </TableCell>
                </TableRow>
              )}

              {Math.ceil(totalPageCount / rowsPerPage) > 1 && (
                <TableRow>
                  <TableCell colSpan={100}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <MUICancelButton
                        title="Previous"
                        sx={{ height: "36px", minWidth: "100px" }}
                        startIcon={
                          <ArrowBackIcon
                            sx={{ color: page === 1 ? "#a2a2a2" : "#414651" }}
                          />
                        }
                        disabled={page === 1}
                        onClick={() => handlePageChange(null, page - 1)}
                      />

                      <Pagination
                        page={page}
                        onChange={handlePageChange}
                        count={Math.ceil(totalPageCount / rowsPerPage)}
                        siblingCount={1}
                        boundaryCount={1}
                        shape="rounded"
                        hidePrevButton
                        hideNextButton
                      />

                      <MUICancelButton
                        title="Next"
                        startIcon={
                          <ArrowForwardIcon
                            sx={{
                              color:
                                page === Math.ceil(totalPageCount / rowsPerPage)
                                  ? "#a2a2a2"
                                  : "#414651",
                            }}
                          />
                        }
                        onClick={() => handlePageChange(null, page + 1)}
                        sx={{ height: "36px", minWidth: "100px" }}
                        disabled={
                          page === Math.ceil(totalPageCount / rowsPerPage)
                        }
                      />
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </Paper>
        </Grid2>

        <Grid2 item>
          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            scroll="paper"
            sx={{
              "& .MuiDialog-paper": {
                minHeight: "80vh",
                minWidth: "70vw",
              },
              marginLeft: "70px",
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              History
              <CloseIcon
                sx={{ color: "#52525B", cursor: "pointer" }}
                onClick={handleClose}
              />
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className="tableHeadersCell">Date</TableCell>
                      <TableCell className="tableHeadersCell">
                        Client Name
                      </TableCell>
                      <TableCell className="tableHeadersCell">
                        Job Title
                      </TableCell>
                      <TableCell className="tableHeadersCell">Event</TableCell>
                      <TableCell className="tableHeadersCell">Notes</TableCell>
                      <TableCell className="tableHeadersCell">
                        Processed By
                      </TableCell>
                      <TableCell className="tableHeadersCell">Action</TableCell>
                    </TableRow>
                  </TableHead>

                  {historyTableDatas?.length > 0 ? (
                    <TableBody>
                      {historyTableDatas?.map((item, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor:
                              index % 2 === 1 ? "#FAFAFA" : "inherit",
                            "&:hover": { backgroundColor: "#f1f1f1" },
                          }}
                        >
                          <TableCell className="tableBodyCell">
                            {item?.date
                              ? dayjs(item?.date).format(
                                "DD/MM/YYYY hh:mm:ss A"
                              )
                              : "NA"}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item?.clientName}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item?.jobTitile}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item?.event}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item?.notes ? item?.notes : "NA"}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            {item?.processedBy}
                          </TableCell>
                          <TableCell className="tableBodyCell">
                            <IconButton
                              sx={{ color: item?.deletable && "#fd5c63" }}
                              disabled={!item?.deletable}
                              onClick={() => handleOpenDelete(item)}
                            >
                              <DeleteIcon
                                stroke={item?.deletable ? "red" : "#a2a2a2"}
                                style={{
                                  cursor: !item?.deletable && "not-allowed",
                                  pointerEvents: "auto",
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={8}>
                          <Typography className="emptydatas">
                            No Data Found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MUICancelButton
                title="close"
                onClick={handleClose}
                sx={{ borderColor: "#D6BBFB" }}
              />
            </DialogActions>
          </Dialog>
        </Grid2>
      </Grid2>

      <Grid2 item>
        <Dialog
          open={openDelete}
          onClose={handleCloseDelete}
          scroll="paper"
          maxWidth="xs"
          sx={{
            "& .MuiDialog-paper": {
              width: "90%",
              maxWidth: "500px",
              height: "auto",
              borderRadius: "15px",
              padding: "3px",
            },
          }}
        >
          <DialogContent>
            <DialogContentText>
              <div style={{ display: "flex", gap: "12px", marginTop: "7px" }}>
                <div
                  style={{
                    backgroundColor: "#FEE4E2",
                    borderRadius: "40px",
                    height: "40px",
                    width: "45px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <DeleteIcon stroke={"red"} />
                </div>

                <div>
                  <Typography
                    sx={{ color: "#181D27", fontWeight: 600, fontSize: "17px" }}
                  >
                    Delete Job?
                  </Typography>
                  <Typography
                    sx={{ color: "#535862", fontWeight: 400, fontSize: "14px" }}
                  >
                    Are you sure you want to delete this post? This action
                    cannot be undone.
                  </Typography>
                </div>
              </div>

              <Grid2
                item
                sx={{
                  marginTop: "25px",
                  display: "flex",
                  gap: "10px",
                  justifyContent: "flex-end",
                }}
              >
                <MUICancelButton title="Cancel" onClick={handleCloseDelete} />
                <MUIButton
                  title="Delete"
                  sx={{ backgroundColor: "#D92D20", borderRadius: "10px" }}
                  onClick={handleEventsHistoryDelete}
                />
              </Grid2>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Grid2>
      {eventsTableListDatas?.length > 0 ? (
        <Grid2
          item
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
            marginTop: "20px",
          }}
        >
          <MUICancelButton
            title="Cancel"
            onClick={handleSubmitProfileNavigation}
          />
          {/* {(Profile?.profile.role === 'admin' || Profile?.profile?.role === 'coordinator') && ( */}
          {status !== "Active" ? (
            <></>
          ) : (
            <MUIButton
              title="Save Changes"
              onClick={status === "Active" ? handleSaveHIstory : null}
              sx={{
                backgroundColor: "#7F56D9",
                borderRadius: "7px",
                width: "120px",
              }}
            />
          )}
          {/* )} */}
        </Grid2>
      ) : (
        <></>
      )}

      <Grid2 item>
        <Dialog
          open={openPaymentDialog}
          scroll="paper"
          maxWidth="md"
          className="sidePopup"
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              Payment
              <CloseIcon
                sx={{ color: "#52525B", cursor: "pointer" }}
                onClick={handleClose}
              />
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText>
                <Grid2
                  item
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                  gap={2}
                >
                  <Grid2 item>
                    <InputLabel className="input"> Profile Name</InputLabel>
                    <TextField
                      className="textfields"
                      size="small"
                      placeholder="Enter Profile Name"
                      value={profileName}
                    // disabled={profileName}
                    />
                  </Grid2>

                  <Grid2 item>
                    <InputLabel className="input"> Position Name</InputLabel>
                    <TextField
                      className="textfields"
                      size="small"
                      placeholder="Enter Position Name"
                      value={positionTitle}
                    // disabled={positionTitle}
                    />
                  </Grid2>

                  <Grid2 item>
                    <InputLabel className="input">
                      {" "}
                      Candidate Joining Date{" "}
                    </InputLabel>
                    <Controller
                      control={control}
                      name="joiningDate"
                      render={({ field }) => (
                        <MuiDatePicker
                          {...field}
                          slots={{
                            openPickerIcon: CalendarIcon,
                          }}
                          slotProps={{
                            textField: {
                              size: "small",
                              placeholder: "Enter Candidate Joining Date",
                              InputProps: {
                                sx: { borderRadius: "10px", height: "35px" },
                              },
                            },
                          }}
                          sx={{
                            "& .MuiInputBase-input": {
                              fontSize: "14px",
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: "20px",
                            },
                          }}
                          format="DD-MM-YYYY"
                          minDate={dayjs()}
                        />
                      )}
                    />
                    {errors?.joiningDate?.message && (
                      <div style={{ color: "red", fontSize: "0.8rem" }}>
                        {errors?.joiningDate?.message}
                      </div>
                    )}
                  </Grid2>

                  <Grid2 item>
                    <InputLabel className="input">
                      Candidate Annual Salary
                    </InputLabel>
                    <Controller
                      control={control}
                      name="annualSalary"
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="number"
                          className="textfields"
                          size="small"
                          placeholder="Enter Annual salary"
                        />
                      )}
                    />
                    {errors?.annualSalary?.message && (
                      <div style={{ color: "red", fontSize: "0.8rem" }}>
                        {errors?.annualSalary?.message}
                      </div>
                    )}
                  </Grid2>
                </Grid2>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MUICancelButton
                title="close"
                onClick={handleClose}
                sx={{ borderColor: "#D6BBFB" }}
              />
              <MUIButton
                title="Submit"
                type="Submitt"
                onClose={onSubmit}
              ></MUIButton>
            </DialogActions>
          </form>
        </Dialog>
      </Grid2>

      <Grid2 item>
        <Dialog
          open={openCommissionDialog}
          onClose={handleCloseCommissionDialog}
          scroll="paper"
          maxWidth="xs"
          sx={{
            "& .MuiDialog-paper": {
              width: "90%",
              maxWidth: "500px",
              height: "auto",
              borderRadius: "15px",
              padding: "3px",
            },
          }}
        >
          <DialogTitle dividers sx={{ padding: "15px" }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Typography sx={{ textAlign: "center", fontWeight: 600 }}>
                {message || " Commission is created for all the referrals"}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "5px",
              }}
            >
              <Typography
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                }}
              >
                {" "}
                <img
                  src={Candidate}
                  className="icons"
                  style={{ width: 25, height: 25, color: "#7F56D9" }}
                  alt="Candidate salary"
                />{" "}
                {candidateName || "Ilavarasan"}
              </Typography>
              <Typography
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                }}
              >
                {" "}
                <span style={{ display: "flex", alignItems: "flex-end" }}>
                  {" "}
                  Candidate Salary :
                  <CurrencyRupeeIcon
                    sx={{
                      fontSize: "20px !important",
                      margin: "1px !important",
                      color: "#A4A7AE",
                    }}
                  />{" "}
                  {candidateSalary || "20000"}{" "}
                </span>{" "}
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                {clientCommissionAmount === 0 &&
                  jobCommissionAmount === 0 &&
                  candidateCommissionAmount === 0 && (
                    <span style={{ textAlign: "center" }}>
                      {" "}
                      No commission has been created , Thank you 🤝
                    </span>
                  )}
                {clientCommissionAmount > 0 && (
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={handshake}
                        alt="client image "
                        style={{ width: 30, height: 30, padding: "2px" }}
                      ></img>
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <Typography sx={{ color: "black" }}>
                            {" "}
                            Client Commission{" "}
                          </Typography>
                          <Typography sx={{ fontSize: "14px" }}>
                            {" "}
                            {clientRewardType === "FP"
                              ? `( ${clientRewardPercentage}% )`
                              : `( Rs.${clientRewardPercentage} )`}{" "}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", gap: "20px" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <CurrencyRupeeIcon className="icons" />{" "}
                            {clientCommissionAmount}{" "}
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <PersonIcon className="icons" />{" "}
                            <span style={{ color: "#7F56D9" }}>
                              {" "}
                              {clientCommissionAmountEarnedBy || ""}{" "}
                            </span>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
                {jobCommissionAmount > 0 && (
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={Folders}
                        alt="client image "
                        style={{ width: 30, height: 30, padding: "2px" }}
                      ></img>
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <Typography sx={{ color: "black" }}>
                            {" "}
                            Job Commission
                          </Typography>
                          <Typography sx={{ fontSize: "14px" }}>
                            {" "}
                            {positionRewardType === "FP"
                              ? `( ${positionRewardPercentage}% )`
                              : `( Rs.${positionRewardPercentage} )`}{" "}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", gap: "20px" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <CurrencyRupeeIcon className="icons" />{" "}
                            {jobCommissionAmount}{" "}
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <PersonIcon className="icons" />{" "}
                            <span style={{ color: "#7F56D9" }}>
                              {jobCommissionAmountEarnedBy || ""}
                            </span>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
                {candidateCommissionAmount > 0 && (
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={BonusIcon}
                        alt="client image "
                        style={{ width: 30, height: 30, padding: "2px" }}
                      ></img>
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                          }}
                        >
                          <Typography sx={{ color: "black" }}>
                            {" "}
                            Candidate Commission{" "}
                          </Typography>
                          <Typography sx={{ fontSize: "14px" }}>
                            {" "}
                            {candidateRewardType === "FP"
                              ? `( ${candidateRewardPercentage}% )`
                              : `( Rs.${candidateRewardPercentage} )`}{" "}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", gap: "20px" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <CurrencyRupeeIcon className="icons" />{" "}
                            {candidateCommissionAmount}{" "}
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {" "}
                            <PersonIcon className="icons" />
                            <span style={{ color: "#7F56D9" }}>
                              {candidateCommissionAmountEarnedBy || ""}
                            </span>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MUICancelButton
              title="Ok"
              sx={{ borderRadius: "10px" }}
              onClick={handleCloseCommissionDialog}
            />
          </DialogActions>
        </Dialog>
      </Grid2>
    </Box>
  );
};

export default JobManageEvents;
